import { render } from "./addMenuToUser.vue?vue&type=template&id=b8f51d8c&scoped=true"
import script from "./addMenuToUser.vue?vue&type=script&lang=js"
export * from "./addMenuToUser.vue?vue&type=script&lang=js"

import "./addMenuToUser.vue?vue&type=style&index=0&id=b8f51d8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f51d8c"]])

export default __exports__